export default {
    getRate: () => {
        return JSON.parse(localStorage.getItem("Rate"))
    },
    getIsAuthenticated: () => {
        const cookie = document.cookie;
        let isAuthenticated = cookie.includes("CommonApplicationAuthCookie_.masterweblight-auth");
        return isAuthenticated;
    },
    getSearched: (state) => {
        return state.searched
    },
    getSearchedSecondFilters: (state) => {
        return state.searchedSecondFilters
    },
    getSearchResult: (state) => {
        return state.searchResult
    },
    getSecondaryFiltersResult: (state) => {
        return state.secondaryFiltersResult
    },
    getCashSecondaryFiltersResult: (state) => {
      return state.cashSecondaryFiltersResult
    },
    getPriceTableData: (state) => {
        return state.priceTableData
    },
    getPriceTableDataCities: (state) => {
        return state.priceTableDataCities
    },
    getSearchInOut: (state) => {
        return state.outHotelMode
    },
    getMaxPriceIsSet: (state) => {
        return state.maxPriceIsSet
    },
    getMapItems: (state) => {
        return state.mapItems
    },
    getUserInfo: (state) => {
        return state.userInfo
    },
    getSpecialText: (state, context) => (special, localizeList) => {
        let condition = JSON.parse(special.Condition);

        let from, to, currency,value;

        if (special.SpecialType === 'KickBack') {
            from = condition.DurationFrom;
            to = condition.DurationTo;
            value = condition.Value;
        }
        else if (special.SpecialType === 'EarlyBird' || special.SpecialType === 'PayStay') {
            from = condition.NightsFrom;
            to = condition.NightsTo;
            if (special.SpecialType ==='EarlyBird')
                value = condition.Discount;
            else
                value = condition.NightValue;
        }
        else if (special.SpecialType === 'SpecialTransfer') {
            from = condition.NightsFrom;
            to = condition.NightsTo;
            value = condition.Value;
        }
        currency = condition.OperationType;

        //Если берём строки с датами
        if (special.UntilDate) {
            ///Если акция PayStay
            if (special.SpecialType === "PayStay") {
                return localizeList['SpecialsInformationPayStay']
                    .replace("{0}", from)
                    .replace("{1}", to)
                    .replace("{2}", context.getPayStayOperation(currency, localizeList))
                    .replace("{3}", value)
                    .replace("{4}", context.getCorrectDate(special.UntilDate));
            }
            else if (special.SpecialType === "SpecialTransfer") {
                return localizeList['SpecialsInformationTransfer']
                    .replace("{0}", value)
                    .replace("{1}", context.getSpecialTransferOperation(currency, localizeList))
                    .replace("{2}", from)
                    .replace("{3}", to)
                    .replace("{4}", context.getCorrectDate(special.UntilDate));
            }
            //Если остальные виды акций
            else {
                return localizeList['SpecialsInformation']
                    .replace("{0}", value)
                    .replace("{1}", context.getEarlyBirdKickBackOperation(currency))
                    .replace("{2}", special.SpecialType)
                    .replace("{3}", context.getCorrectDate(special.UntilDate));
            }
        }

        ///Если строки без дат

        ///Если акция PayStay
        if (special.SpecialType === "PayStay") {
            return localizeList['SpecialsInformationPayStayWithoutDate']
                .replace("{0}", from)
                .replace("{1}", to)
                .replace("{2}", context.getPayStayOperation(currency, localizeList))
                .replace("{3}", value)
        }
        else if (special.SpecialType === "SpecialTransfer") {
            return localizeList['SpecialsInformationTransferWithoutDate']
                .replace("{0}", value)
                .replace("{1}", context.getSpecialTransferOperation(currency, localizeList))
                .replace("{2}", from)
                .replace("{3}", to);
        }
        //Если остальные виды акций
        else {
            return localizeList['SpecialsInformationWithoutDate']
                .replace("{0}", value)
                .replace("{1}", context.getEarlyBirdKickBackOperation(currency))
                .replace("{2}", special.SpecialType)
        }
    },
    getCorrectDate:() => (date) => {
        if (!date) return '';

        let res = date.split("T")[0].split("-").reverse().join(".");
        //res = moment(date).format("DD/MM");
        return res;
    },
    getSpecialTransferOperation: () => (val) => {
        if (val === 2)
            return 'у.е.';
        else return '%';
    },
    getEarlyBirdKickBackOperation: () => (val) => {
        if (val === 2)
            return 'у.е.';
        else return '%';
    },
    getPayStayOperation: () => (type, localizeList) => {
        const minus = localizeList['PayStayOperationMinus'];
        const plus = localizeList['PayStayOperationPlus'];
        const equal = localizeList['PayStayOperationEqual'];

        switch (type) {
            case 0:
                return equal;
            case 1:
                return plus;
            default:
                return minus;
        }
    },
    getCollapse: (state) => {
        return state.collpse
    },
    getShowTourResultList: (state) => {
      return state.showTourResultList
    },
    getSearchLoaderStatus: (state) => {
      return state.searchLoaderStatus;
    },
    getOnMountedChangeDaysFlag: (state) => {
      return state.onMountedChangeDaysFlag;
    },
    getCommonSearchFlag: (state) => {
    return state.commonSearchFlag;
    },
    getSearchSecondParamsCounter: (state) => {
      return state.searchSecondParamsCounter
    },
    getFirstSearch: (state) => {
      return state.firstSearch
    },
    getMainSearchCount: (state) => {
      return state.mainSearchCount
    },
    getFilterParams: (state) => {
      return state.filterParams
    },
    getCheckFilterSelect: (state) => {
      return state.checkFilterSelect
    },
}
